import styled from "styled-components"

export const FeedbackContainer = styled.div`
  text-align: left;
  display: flex;
  padding: 10px 20px;
  width: 100%;
  border: 1px solid #e7e7e7;
  border-left: 1px solid #2a2e33;
  margin: 10px 0px;
  h3 {
    margin: 0px;
  }
`
